// extracted by mini-css-extract-plugin
export default {"container":"changeStudentPayment_container__wXZKQ","change":"changeStudentPayment_change__-IB6d"};